module.exports = __webpack_public_path__ + "img/posologie-hamid-synthese-2.805c20f7.png";